module.exports = __webpack_public_path__ + "images/b66d56c368e8befb9fa6eaa36bb5e1d0.jpg";